import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";
import "./Contact.css";

const SOCIAL_LINKS = [
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61587216670698" },
  { label: "X", href: "https://x.com/zolaid" },
  { label: "Instagram", href: "https://instagram.com/zolaid1" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/zolaid/about/" },
];

export default function Contact() {
  return (
    <MarketingLayout>
      <div className="marketing-page-content contact-page">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Company</p>
          <h1>Contact</h1>
          <p className="page-lead">
            Questions, feedback, or partnership ideas — we read every message and usually reply within one business day.
          </p>
        </header>

        <div className="contact-channels">
          <section className="marketing-section-card contact-channel-card" aria-labelledby="contact-email">
            <span className="marketing-kicker" aria-hidden>Email</span>
            <h2 id="contact-email" className="marketing-section-title">Write to Zolaid</h2>
            <p className="marketing-section-text" style={{ marginBottom: "0.85rem" }}>
              Support, billing, teams, and partnerships.
            </p>
            <a href="mailto:hello@zolaid.com" className="contact-link">
              hello@zolaid.com
            </a>
          </section>
        </div>

        <section className="marketing-section-card" aria-labelledby="contact-social">
          <h2 id="contact-social" className="marketing-section-title">Follow Zolaid</h2>
          <p className="marketing-section-text">
            Product updates and company news on the channels we actively maintain.
          </p>
          <div className="contact-social-row">
            {SOCIAL_LINKS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-chip"
              >
                {item.label}
              </a>
            ))}
          </div>
        </section>

        <div className="marketing-cta-row">
          <Link to="/chatbot" className="marketing-cta">
            Open Zolaid
          </Link>
          <Link to="/Support" className="marketing-cta marketing-cta--secondary">
            Visit Support
          </Link>
        </div>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
